export * from './fixed-number.pipe';
